module.exports = __webpack_public_path__ + "img/logo.115e4747.png";